import { matrixAdapterGreengrassComponentName } from './greengrass-component-names.js';
import { GatewayAdapterKeySchema, toThingGroupSuffix } from './gateway-adapter-common.js';
export const LocationAdapterKeySchema = GatewayAdapterKeySchema;
export { toThingGroupSuffix };
export const LOCATION_ADAPTER_REGISTRY = [
    {
        locationAdapterKey: 'woxu-ls1000',
        systemType: 'uwb',
        displayName: 'Woxu LS-1000 UWB Location Engine',
        greengrassComponentName: matrixAdapterGreengrassComponentName('woxu-ls1000'),
        thingGroupSuffix: toThingGroupSuffix('woxu-ls1000'),
        defaultInstallPath: 'C:\\Cnapse\\LS1000-location-engine',
    },
];
const REGISTRY_BY_KEY = new Map(LOCATION_ADAPTER_REGISTRY.map((e) => [e.locationAdapterKey, e]));
export function getLocationAdapterRegistryEntry(locationAdapterKey) {
    const key = LocationAdapterKeySchema.parse(locationAdapterKey);
    const found = REGISTRY_BY_KEY.get(key);
    if (!found) {
        throw new Error(`Unknown locationAdapterKey: ${key}`);
    }
    return found;
}
export function listLocationAdapterRegistryEntries() {
    return [...LOCATION_ADAPTER_REGISTRY];
}
export function getSystemTypeForLocationAdapter(locationAdapterKey) {
    return getLocationAdapterRegistryEntry(locationAdapterKey).systemType;
}
//# sourceMappingURL=location-adapter-registry.js.map